export const AdTag = () => {
  return (
    <svg
      width="28"
      height="18"
      viewBox="0 0 28 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="28" height="18" rx="9" fill="#4D525C" />
      <path
        d="M6.2041 13L8.99707 5.22266H10.3667L13.165 13H11.9028L9.71143 6.646H9.64697L7.4502 13H6.2041ZM11.6987 9.95459V10.9429H7.65967V9.95459H11.6987ZM15.2403 13V11.9634H17.0987C17.6859 11.9634 18.1747 11.8524 18.565 11.6304C18.9553 11.4084 19.2471 11.0861 19.4404 10.6636C19.6374 10.2375 19.7359 9.71647 19.7359 9.10059C19.7359 8.49186 19.6392 7.97624 19.4458 7.55371C19.256 7.1276 18.9696 6.80534 18.5864 6.58691C18.2069 6.36849 17.7342 6.25928 17.1685 6.25928H15.1973V5.22266H17.2383C18.001 5.22266 18.6563 5.37663 19.2041 5.68457C19.7556 5.99251 20.1763 6.43831 20.4663 7.02197C20.7599 7.60563 20.9068 8.2985 20.9068 9.10059C20.9068 9.90983 20.7582 10.6063 20.461 11.1899C20.1673 11.7736 19.7394 12.2212 19.1773 12.5327C18.6187 12.8442 17.9491 13 17.1685 13H15.2403ZM15.8257 13H14.6441V5.22266H15.8257V13Z"
        fill="white"
      />
    </svg>
  );
};
